import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { Router, RouterModule } from '@angular/router';
import { HttpClient, HttpContext } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { SuperAdminService } from '../../services/super-admin.service';
import { FormFieldsSelectDataService } from '../../shared/form-fields-select-data.service';
import { backendEndPointToken } from '../../app.config';
import { DisableSortParam } from '../../loading.interceptor';

@Component({
  selector: 'app-superadmin-dashboard',
  standalone: true,
  imports: [CommonModule, MatCardModule, MatIconModule, MatButtonModule, RouterModule],
  templateUrl: './superadmin-dashboard.component.html',
  styleUrls: ['./superadmin-dashboard.component.scss']
})
export class SuperAdminDashboardComponent implements OnInit {
  private http = inject(HttpClient);
  private superAdminService = inject(SuperAdminService);
  private formDataService = inject(FormFieldsSelectDataService);
  private backendUrl = inject(backendEndPointToken);
  private router = inject(Router);

  pendingOrgCount = 0;
  localTerminologyStatus: 'none' | 'partial' | 'complete' = 'none';
  loadedResourcesCount = 0;
  totalResourcesCount = 3;

  systemResources = [
    { url: 'https://elikita-server.daalitech.com/CodeSystem/Substance/SubstanceCode', exists: false },
    { url: 'https://elikita-server.daalitech.com/CodeSystem/ServiceRequest/ServiceRequestCodes', exists: false },
    { url: 'https://elikita-server.daalitech.com/CodeSystem/observation-loinc', exists: false },
  ];

  async ngOnInit() {
    await this.loadPendingOrgs();
    await this.checkSystemResources();
  }

  async loadPendingOrgs() {
    try {
      const pending = await firstValueFrom(this.superAdminService.getPendingApprovals());
      this.pendingOrgCount = pending.length;
    } catch (error) {
      console.error('Error fetching pending orgs', error);
    }
  }

  async checkSystemResources() {
    let existsCount = 0;
    for (const res of this.systemResources) {
      try {
        const response: any = await firstValueFrom(this.http.get(`${this.backendUrl}/CodeSystem?url=${res.url}&_total=accurate`, {
          context: new HttpContext().set(DisableSortParam, true)
        }));
        res.exists = (response.total > 0) || (response.entry && response.entry.length > 0);
        if (res.exists) existsCount++;
      } catch (error) {
        res.exists = false;
      }
    }
    this.loadedResourcesCount = existsCount;
    if (existsCount === 0) this.localTerminologyStatus = 'none';
    else if (existsCount === this.totalResourcesCount) this.localTerminologyStatus = 'complete';
    else this.localTerminologyStatus = 'partial';
  }

  navigateToOrganizations() {
    this.router.navigate(['/app/organizations']);
  }

  navigateToLocalTerminologies() {
    this.router.navigate(['/app/terminology-migration'], { queryParams: { tab: 2 } });
  }

  navigateToFhirSync() {
    this.router.navigate(['/app/terminology-migration'], { queryParams: { tab: 0 } });
  }
}
